// The name a Download Preview PNG is saved under, so a folder of them can be
// told apart: lowercase ASCII words joined by hyphens, from the board and the
// subject of the message or Broadcast the image shows. Claude's previews build
// the same name in app/services/mcp/preview_file_name.rb, and both specs check
// spec/support/fixtures/preview_file_names.json. Only names the admin wrote go
// in, never a recipient's.

// Each part is cut back to a whole word within this many characters.
const MAX_PART_LENGTH = 60;

const slug = text => {
  const words = String(text ?? '')
    .normalize('NFKD')
    .replace(/\P{ASCII}/gu, '') // accent marks, emoji, curly quotes
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  if (words.length <= MAX_PART_LENGTH) return words;

  const cut = words.slice(0, MAX_PART_LENGTH + 1);
  const lastHyphen = cut.lastIndexOf('-');
  return lastHyphen > 0
    ? cut.slice(0, lastHyphen)
    : words.slice(0, MAX_PART_LENGTH);
};

/**
 * A reminder is named after its message's subject: reminder subjects mostly
 * repeat it after "Don't Miss:".
 *
 * @param {object} parts
 * @param {string} [parts.board]
 * @param {string} [parts.subject] The message's subject, for its reminder too.
 * @param {boolean} [parts.reminder]
 * @param {'email' | 'text'} parts.channel
 * @returns {string} e.g. acme-benefits-open-enrollment-starts-monday-reminder-text.png
 */
export const campaignMessageFileName = ({
  board,
  subject,
  reminder,
  channel,
}) => {
  const parts = [board, subject].map(slug).filter(Boolean);
  if (parts.length === 0) {
    return `${reminder ? 'reminder-' : ''}${channel}-preview.png`;
  }

  return `${[...parts, reminder && 'reminder', channel]
    .filter(Boolean)
    .join('-')}.png`;
};

/**
 * @param {object} parts
 * @param {string} [parts.board]
 * @param {string} [parts.title] The Broadcast's subject, or a text-only
 *   Broadcast's text as written (with its {{tokens}}, never filled in for a
 *   recipient).
 * @param {'email' | 'text'} parts.channel
 * @returns {string} e.g. acme-benefits-broadcast-open-enrollment-starts-monday-email.png
 */
export const broadcastFileName = ({ board, title, channel }) => {
  const boardSlug = slug(board);
  const titleSlug = slug(title);
  if (!boardSlug && !titleSlug) return `broadcast-${channel}-preview.png`;

  return `${[boardSlug, 'broadcast', titleSlug, channel]
    .filter(Boolean)
    .join('-')}.png`;
};
